"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function KubernetesGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__kubernetes-green-multitone-filled__clip0_13467_120)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M5.143 15.392a1.175 1.175 0 01-.94-.454L.655 10.533a1.199 1.199 0 01-.23-1.034l1.264-5.482a1.198 1.198 0 01.658-.838L7.473.727a1.202 1.202 0 011.053 0l5.126 2.44a1.214 1.214 0 01.658.822l1.264 5.482a1.225 1.225 0 01-.23 1.034l-3.548 4.421a1.21 1.21 0 01-.94.454H5.143v.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M13.554 3.12l-.137.133-10.31 10.318L.658 10.53a1.175 1.175 0 01-.235-1.03L1.69 4.017a1.198 1.198 0 01.658-.838L7.473.727c.164-.08.345-.12.528-.117.182 0 .362.04.525.121l5.028 2.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.123 9.115H13.1h-.06a1.878 1.878 0 00-.191-.02.481.481 0 01-.102 0 2.847 2.847 0 01-.544-.093.195.195 0 01-.114-.11v-.02l-.133-.043a3.965 3.965 0 00-.07-1.425 4.114 4.114 0 00-.568-1.328l.102-.09v-.023a.227.227 0 01.05-.149c.142-.12.294-.225.455-.317.031-.02.062-.027.094-.051.06-.029.117-.062.172-.098a.631.631 0 01.047-.043s.024 0 .024-.02a.337.337 0 00.07-.454.289.289 0 00-.235-.113.391.391 0 00-.223.082l-.02.02c-.02 0-.031.03-.05.039-.047.045-.09.093-.13.145-.023 0-.043.05-.07.07a2.553 2.553 0 01-.392.364.169.169 0 01-.09.032.117.117 0 01-.063 0h-.02l-.12.082c-.134-.141-.275-.263-.416-.392a4.068 4.068 0 00-2.118-.838V4.19h-.02a.211.211 0 01-.145-.192 3.407 3.407 0 01.032-.544.313.313 0 01.031-.102c0-.059.02-.121.031-.192v-.102a.317.317 0 10-.63 0v.083c0 .065.01.13.031.191a2.741 2.741 0 01.05.65.204.204 0 01-.081.13l-.02.023v.13a5.143 5.143 0 00-.548.082 3.916 3.916 0 00-2.028 1.143l-.102-.074h-.063a.18.18 0 01-.09-.032 2.648 2.648 0 01-.391-.391.427.427 0 00-.075-.07c-.04-.052-.083-.1-.129-.146a.298.298 0 01-.05-.039h-.02a.356.356 0 00-.224-.082.286.286 0 00-.235.114.337.337 0 00.07.454h.024c.024 0 .028.027.051.039.055.037.11.07.169.102.034.01.066.028.094.05.161.09.313.195.454.314a.188.188 0 01.05.153v.02l.103.09a.47.47 0 00-.051.082 3.967 3.967 0 00-.568 2.674l-.13.04a.25.25 0 01-.109.113c-.18.048-.363.078-.548.09a1.217 1.217 0 00-.294.023h-.059a.035.035 0 00-.03 0 .325.325 0 00-.263.372.31.31 0 00.325.235.192.192 0 00.078 0h.063a.822.822 0 00.18-.07c.031 0 .062-.032.094-.04.162-.055.33-.093.501-.113h.02a.243.243 0 01.133.051h.02l.14-.02a4.01 4.01 0 001.328 1.907c.14.106.284.204.434.294l-.062.13v.019c.02.053.02.111 0 .164-.072.166-.16.325-.263.474-.02.031-.039.051-.062.082-.04.051-.077.105-.11.161a.288.288 0 00-.031.05.046.046 0 010 .02.321.321 0 00.129.435c.038.02.08.03.121.031a.39.39 0 00.306-.191.027.027 0 010-.02.194.194 0 01.027-.05c.025-.06.046-.122.063-.185l.031-.09a2.35 2.35 0 01.212-.505c.039-.063.09-.07.129-.094a.027.027 0 00.023 0l.07-.133a3.955 3.955 0 002.3.164c.176-.043.352-.094.524-.153l.063.11h.02a.193.193 0 01.133.09c.082.163.153.332.211.505l.031.09c.016.063.036.124.06.184l.03.051v.02a.337.337 0 00.302.192.301.301 0 00.274-.212.391.391 0 00.05-.219v-.02a.834.834 0 00-.141-.211c-.019-.031-.038-.05-.058-.082a2.19 2.19 0 01-.286-.47.283.283 0 010-.165v-.02l-.047-.12a3.916 3.916 0 001.336-1.309c.181-.282.325-.588.427-.908l.12.02h.02a.259.259 0 01.13-.051h.023c.18.033.355.084.525.152a.624.624 0 00.09.04c.059.03.12.055.184.074h.059a.035.035 0 01.031 0 .278.278 0 00.078 0 .336.336 0 00.325-.231.391.391 0 00-.293-.333h.031zm-4.699-.497l-.435.215-.446-.211-.106-.482.302-.391h.481l.306.391-.102.478zm2.643-1.054c.078.335.102.68.07 1.023L9.572 8.14a.274.274 0 01-.176-.325.259.259 0 01.063-.11l1.226-1.104c.179.3.31.624.391.963h-.008zm-.873-1.566l-1.324.94a.27.27 0 01-.356-.059.231.231 0 01-.05-.113l-.09-1.649c.692.074 1.34.384 1.832.877l-.012.004zm-2.937-.83l.325-.063-.09 1.621a.278.278 0 01-.395.235L5.75 5.998a3.074 3.074 0 011.507-.83zM5.276 6.601l1.206 1.057a.27.27 0 01.027.392.207.207 0 01-.121.082l-1.567.455A3.281 3.281 0 015.276 6.6zm-.274 2.741l1.609-.274a.278.278 0 01.286.212.325.325 0 010 .164l-.634 1.492a3.18 3.18 0 01-1.265-1.59l.004-.004zm3.696 2.017a3.3 3.3 0 01-1.73-.082l.783-1.45a.27.27 0 01.325-.07.462.462 0 01.12.11l.784 1.41c-.09.031-.192.05-.294.082h.012zm1.958-1.41c-.248.395-.58.73-.971.983l-.638-1.531a.27.27 0 01.14-.313.352.352 0 01.146-.028l1.617.27c-.061.222-.16.432-.294.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M5.143 15.783a1.586 1.586 0 01-1.23-.603L.35 10.79a1.566 1.566 0 01-.306-1.37L1.31 3.938a1.586 1.586 0 01.87-1.112L7.303.374a1.633 1.633 0 011.398 0l5.118 2.44a1.598 1.598 0 01.873 1.088l1.265 5.483a1.628 1.628 0 01-.297 1.378l-3.56 4.41a1.61 1.61 0 01-1.245.602l-5.713.008zM8 1a.756.756 0 00-.352.082L2.515 3.53a.807.807 0 00-.442.553L.804 9.584a.822.822 0 00.16.705L4.49 14.69a.81.81 0 00.634.31h5.713a.84.84 0 00.639-.313l3.524-4.406a.81.81 0 00.152-.7l-1.264-5.483a.783.783 0 00-.447-.556L8.358 1.08A.807.807 0 008 1.001z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__kubernetes-green-multitone-filled__clip0_13467_120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

KubernetesGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
KubernetesGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = KubernetesGreenMultitoneFilled;
exports["default"] = _default;